import Link from "@mui/material/Link";
import FlexRowCenter from "designSystem/components/flex/FlexRowCenter";
import { useLocale } from "designSystem/locale";
import OverflowText from "designSystem/components/text/OverflowText";
import Text from "designSystem/components/text/Text";
import def from "csi/def";
import { useDataSetupStore } from "csi/state/datasetup";
import { useStore } from "csi/state/hooks";
import { getLocationForUrl } from "csi/utility/routerUtility";
import { observer } from "mobx-react-lite";
import React, { Fragment } from "react";

export const DataSetupBreadcrumb = observer(() => {
	const loc = useLocale();
	const dataSetupStore = useDataSetupStore();
	const { routerStore, sessionStore } = useStore();
	const { activeItem, activeSection } = dataSetupStore;
	const { renderDataSetupInstance, locationAncestorNodes, getNodeLocationName } = routerStore;
	const margins = { margin: "0 4px" };
	let ancestors = renderDataSetupInstance ? locationAncestorNodes : null;

	// filter out QuestionSection from ancestors since it is not supposed to be exposed to the user
	ancestors = ancestors?.filter((node) => node.$Type !== "QuestionSection");

	return (
		<FlexRowCenter flexShrink={0} height={26}>
			<OverflowText
				color="textSecondary"
				semiBold
				style={{ flexShrink: 0 }}
				text={activeSection.name}
			/>
			{renderDataSetupInstance && (
				<Fragment>
					<Text style={margins} text="/" />
					<Link
						href={activeItem.href}
						style={{ flexShrink: ancestors.length ? 0 : 1 }}
					>
						<OverflowText
							semiBold
							text={activeItem.name}
						/>
					</Link>
					{ancestors.reverse().map((node) => {
						const { $Type, $URL } = node;

						if (!def.canNavigateToType($Type)) {
							return null;
						}

						const name = getNodeLocationName($URL);
						const title = `${loc.type($Type)}: ${name}`;

						return (
							<Fragment key={$URL}>
								<Text style={margins} text="/" />
								<Link href={getLocationForUrl($URL)}>
									<OverflowText
										semiBold
										text={name}
										tooltipProps={{
											disableHoverListener: false,
											title,
										}}
									/>
								</Link>
							</Fragment>
						);
					})}
				</Fragment>
			)}
		</FlexRowCenter>
	);
});

export default DataSetupBreadcrumb;
